// extracted by mini-css-extract-plugin
export default {"error_message__text":"ErrorMessage_error_message__text__pT8iG"};